// extracted by mini-css-extract-plugin
export default {"checklist":"webpack-components-shared-IconChecklist-IconChecklist-module__checklist"};